// Copyright (c) 2016 Deere & Company

import * as storeConfigurator from './store-configurator';
import alertMessagesReducer from './shared/reducers/alert-messages';
import appConfigReducer from './app-config/reducers';
import columnApi from './reports/shared/reducers/column-api';
import {combineReducers} from 'redux';
import customer from './customer/shared/reducers';
import customerFailed from './shared/reducers/customer-failed';
import dealerRecommendationsReducer from './product/dealer-recommendations/reducers';
import exportToExcel from './shared/reducers/export-to-excel';
import factoryDuplicatePinPlate from './product/factory-users-duplicate-pin-plate/reducers';
import {getCombinedReducers as getCombinedAppReducers} from './app/reducers';
import {getCombinedReducers as getCombinedClaimReducers} from './claim/claim-reducers';
import {getCombinedReducers as getCombinedDuplicatePinPlateRequestReducers} from './product/duplicate-pin-plate/reducers';
import {getCombinedReducers as getCombinedHomeReducers} from './home-page/reducers';
import {getCombinedReducers as getCombinedPartRequestReducers} from './part-requests/part-requests-reducers';
import {getCombinedReducers as getCombinedPipReducers} from './pip/pip-reducers';
import {getCombinedReducers as getCombinedProductRegistrationReducers} from './product/product-registration/reducers';
import {getCombinedReducers as getCombinedProductsByCustomerReducers} from './product/products-by-customer/reducers';
import {getCombinedReducers as getCombinedReimbursementSummaryReducers} from './reimbursement-summary/reimbursement-summary-reducers';
import {getCombinedReducers as getCombinedReportsReducers} from './reports/reports-reducers';
import {getCombinedReducers as getCombinedRgaReducers} from './rga/rga-reducers';
import {getCombinedReducers as getCombinedTabmReducers} from './tabm/tabm-reducers';
import {getCombinedReducers as getCombinedTcsmReducers} from './tcsm/tcsm-reducers';
import {getCombinedReducers as getCombinedUserReducers} from './user/shared/reducers';
import gridApi from './reports/shared/reducers/grid-api';
import latestPerUnitMeasurements from './shared/reducers/latest-per-unit-measurements';
import machineStatusUpdate from './product/machine-status-update/reducers';
import newTransfer from './product/new-transfer/reducers';
import productDealerSearch from './product/dealer-search/reducers';
import productDetails from './product/details/reducers';
import productSearch from './product/search/reducers';
import registrationReview from './product/registration-review/reducers';
import reportVariant from './reports/shared/reducers/report-variant';
import {routerReducer} from 'react-router-redux';
import statusChange from './product/status-change-request/reducers';
import transferApprovals from './product/transfers/reducers';
import updateUnitMeasurements from './shared/reducers/update-unit-measurements';

let store;

const createStore = () => {

    const reducer = combineReducers({
        ...customer,
        ...newTransfer,
        ...productDealerSearch,
        ...productDetails,
        ...productSearch,
        ...registrationReview,
        ...machineStatusUpdate,
        ...statusChange,
        ...transferApprovals,
        ...dealerRecommendationsReducer,
        ...factoryDuplicatePinPlate,
        alertMessages: alertMessagesReducer,
        app: getCombinedAppReducers(),
        appConfig: appConfigReducer,
        claims: getCombinedClaimReducers(),
        columnApi,
        customerFailed,
        duplicatePinPlateRequest: getCombinedDuplicatePinPlateRequestReducers(),
        exportToExcel,
        gridApi,
        home: getCombinedHomeReducers(),
        latestPerUnitMeasurements,
        partReturns: getCombinedPartRequestReducers(),
        pips: getCombinedPipReducers(),
        productRegistration: getCombinedProductRegistrationReducers(),
        productsByCustomer: getCombinedProductsByCustomerReducers(),
        reimbursementSummary: getCombinedReimbursementSummaryReducers(),
        reportVariant,
        reports: getCombinedReportsReducers(),
        rga: getCombinedRgaReducers(),
        routing: routerReducer,
        tabm: getCombinedTabmReducers(),
        tcsm: getCombinedTcsmReducers(),
        updateUnitMeasurements,
        user: getCombinedUserReducers()
    });

    return storeConfigurator.create(reducer);

};

export const getStore = () => {

    if (!store) {

        store = createStore();

    }

    return store;

};

/* eslint-disable no-undefined */

export const destroyStore = () => {

    store = undefined;

};

/* eslint-enable no-undefined */



// WEBPACK FOOTER //
// ./src/store-factory.js